import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Pagos',
    path: '/pagos/consulta-pagos',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const PagadosPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Consulta de pagos</PageTitle>
      <View />
    </>
  );
};

export { PagadosPage };
